import { Stethoscope, Search, Map, ArrowRight } from "lucide-react";
import { DotField } from "./decor";
import { AUDIT } from "../data";
import { Reveal, CTAButton } from "./primitives";

const ICONS = [Search, Stethoscope, Map];

export const Audit = () => (
  <section data-testid="audit-section" className="relative isolate overflow-hidden bg-white py-24 md:py-32">
    <DotField className="opacity-[0.06]" />
    <div className="pointer-events-none absolute right-1/4 top-0 h-80 w-80 rounded-full bg-brand/10 blur-[140px]" />
    <div className="relative mx-auto max-w-6xl px-6 md:px-8">
      <Reveal>
        <div className="rounded-3xl border border-brand/30 bg-white p-8 shadow-[0_0_60px_rgba(140,198,63,0.08)] md:p-14">
          <span className="inline-flex items-center gap-2 rounded-full border border-brand/40 bg-brand/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#5C8A1E]">
            <Stethoscope className="h-3.5 w-3.5" /> GTM Strategy Audit
          </span>
          <h2 className="mt-6 max-w-3xl font-serif text-3xl font-medium tracking-tight text-[#23271F] sm:text-4xl lg:text-5xl">
            {AUDIT.title}
          </h2>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-[#4c5445] sm:text-base">{AUDIT.body}</p>

          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {AUDIT.steps.map((s, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={i} delay={i * 0.08}>
                  <div className="rounded-2xl border border-line bg-[#F4F6F0] p-6">
                    <div className="mb-4 flex items-center gap-3">
                      <span className="grid h-10 w-10 place-items-center rounded-xl border border-brand/40 bg-brand/10 text-[#5C8A1E]">
                        <Icon className="h-5 w-5" strokeWidth={1.8} />
                      </span>
                      <span className="font-serif text-2xl font-semibold text-[#cfd6c2]">0{i + 1}</span>
                    </div>
                    <h3 className="font-serif text-lg font-medium text-[#23271F]">{s.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-[#586150]">{s.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <div className="mt-12 flex flex-col items-start gap-6 border-t border-line pt-8 sm:flex-row sm:items-center sm:justify-between">
            <p className="max-w-md font-serif text-lg italic text-[#5C8A1E]">{AUDIT.kicker}</p>
            <CTAButton testId="audit-cta" href="#contact" className="shrink-0">
              Book Your 30-Min Audit <ArrowRight className="h-4 w-4" />
            </CTAButton>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
